import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

export const getLoadTypes: DocumentNode = gql`
  query loadTypes {
    loadTypeDefaults {
      id
      description
    }
  }
`;

export const getAreaCodes: DocumentNode = gql`
  query areaCodes {
    areaCodes(orderBy: postCode_ASC) {
      id
      area
      postCode
    }
  }
`;
